import React from 'react';
import { Link } from 'react-router-dom';
import '../../styles/main.css';
import Header from '../../components/Header';
import Footer from '../../components/Footer';

function Main() {
    return (
        <div className="App">
            <Header />

            <main className="main-content">

                <p className="intro-paragraph">Learn NLP</p>
                <div className="section-links">
                    <Link to="/begin">Begin</Link>
                    <Link to="/foundations">Foundations</Link>
                    <Link to="/nlpbasics">NLP Basics</Link>
                    <Link to="/ml">Machine Learning</Link>
                    <Link to="/llms">Large Language Models</Link>
                    <Link to="/existingmodels">Current Standard</Link>
                    <Link to="/frontier">Frontier</Link>
                </div>

                <a className="back-to-index" href="/" aria-label="back to barinderthind.com" title="barinderthind.com">
                    <svg viewBox="0 0 24 24" aria-hidden="true"><path fill="currentColor" d="M12 3 2 12h3v8h6v-5h2v5h6v-8h3L12 3z"/></svg>
                </a>
            </main>
            <Footer />
        </div>
    );
}

export default Main;
